export * from "./flexPanel.pure";

import { RegisterFlexPanel } from "./flexPanel.pure";
RegisterFlexPanel();
